import { createContext, useContext, useEffect } from 'react';
export const RuleGroupContext = /*#__PURE__*/createContext(null);
export const useRuleGroupRegistration = () => {
  const context = useContext(RuleGroupContext);
  if (!context) {
    throw new Error('useRuleGroupRegistration must be used within RuleGroupList');
  }
  return context;
};
export const useRegisterRuleGroup = ruleGroup => {
  const {
    registerGroup,
    unregisterGroup
  } = useRuleGroupRegistration();
  useEffect(() => {
    registerGroup({
      groupId: ruleGroup.groupId,
      ruleGroup
    });
  }, [ruleGroup, registerGroup]);
  useEffect(() => () => {
    unregisterGroup(ruleGroup.groupId);
  }, [ruleGroup.groupId, unregisterGroup]);
};
//# sourceMappingURL=rule-group-registration-context.js.map